import { Button, Stack, Tooltip } from "@mui/material";

import { useDisclosure } from "hooks";

import { AddShipmentTrackingLinkModal } from "../AddShipmentTrackingLinkModal";
import { DeleteShipmentTrackingLinkModal } from "../DeleteShipmentTrackingLinkModal";

interface Props {
  shipmentId: number;
  shipmentType: ShipmentType;
  onRefresh: () => void;
  trackingLinkId: number;
}

export function ShipmentTrackingLinkActions(props: Props) {
  const { shipmentId, shipmentType, onRefresh, trackingLinkId } = props;
  const {
    isOpen: isUpdateOpen,
    onOpen: onUpdateOpen,
    onClose: onUpdateClose,
  } = useDisclosure(false);
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure(false);

  return (
    <>
      <Stack direction="row" spacing={1} justifyContent="flex-start">
        <Tooltip
          describeChild
          title="Replace the current tracking link for everyone who can see this shipment."
        >
          <Button variant="contained" onClick={onUpdateOpen}>
            Update
          </Button>
        </Tooltip>
        <Tooltip
          describeChild
          title="Remove the tracking link from this shipment and from the shipper's customers."
        >
          <Button variant="outlined" color="warning" onClick={onDeleteOpen}>
            Delete
          </Button>
        </Tooltip>
      </Stack>
      <AddShipmentTrackingLinkModal
        isOpen={isUpdateOpen}
        onClose={onUpdateClose}
        shipmentId={shipmentId}
        shipmentType={shipmentType}
        onRefresh={onRefresh}
      />
      <DeleteShipmentTrackingLinkModal
        isOpen={isDeleteOpen}
        onClose={onDeleteClose}
        shipmentType={shipmentType}
        onRefresh={onRefresh}
        trackingLinkId={trackingLinkId}
      />
    </>
  );
}
